/*
  Click Fencing — free Perth metro delivery over $3,000, 2026-09-22.

  Shopify's own local delivery zone ("Perth metro delivery - FREE over
  $3,000": $75 under, free from $3,000, 50km radius) already exists at
  checkout. The calculators never learned about it: every one of the four
  still shows "🚚 Delivery (+$90)" and, when Delivery is chosen, always adds
  a flat $90/$99 "Perth Metro Delivery" line to the quote total regardless of
  the kit subtotal - Leesa's quote read $4,628.78 while Shopify (correctly)
  charged $4,529.78 at checkout. So the calculator was over-quoting every
  order over $3,000 that chose delivery.

  Root cause lives inside each 700KB calculator source (ullc-calc.js,
  flat-top.js, blade.js, perfmesh-calc.js), each with its own
  `deliveryCharge` block ("Delivery charge" comment, `this.state.quoteBreakdown.push({category:'Delivery', item:'Perth Metro Delivery', ...})`).
  Same style as every other cf-*.js patch in this theme: correct it at
  runtime rather than hand-edit four giant files for one condition, so the
  fix is one small, auditable, self-installing asset instead of four
  separately-risked surgeries.

  window.glassCalculator is the live, DOM-bound calculator instance on ALL
  FOUR calculator pages (see click-fencing-calculators skill, the corrected
  reachability note, 2026-09-01) - so one script, run everywhere, fixes all
  four.

  WHAT THIS DOES, every ~350ms while a calculator page is open:
    1. Reads state.quoteBreakdown for a live (non-zero, non-pickup) "Perth
       Metro Delivery" line.
    2. Computes the kit subtotal = everything else in the breakdown (i.e.
       the delivery-line's own totalPrice subtracted out).
    3. >= $3,000 -> zero the line, relabel it "Perth metro delivery — FREE
       (over $3,000)", and correct the rendered $ totals on screen by the
       exact amount removed. < $3,000 -> put the calculator's OWN charge
       back untouched (never invents a price).
    4. Relabels the "🚚 Delivery (+$90)" radio once, on every page, to
       "🚚 Delivery (FREE over $3,000)" — informational, shown regardless of
       the current subtotal.
    5. Shows a one-line nudge under the delivery note when the kit subtotal
       is under $3,000 and greater than $0: "Add $X more for FREE Perth
       metro delivery".

  This never touches cart/checkout (Shopify's own zone is already correct
  there) and never touches cf-calc-price-lock.js's per-SKU cut-price lock -
  it only corrects the DELIVERY line and the totals that include it.

  Because it corrects state.quoteBreakdown in place (not a clone), anything
  that reads state afterwards - the on-page breakdown, quote-review's saved
  copy via proceedToQuotePage(), the CRM enquiry, and the new branded PDF -
  all inherit the corrected figure with no separate delivery-aware code of
  their own.
*/
(function () {
  'use strict';
  if (window.__cfFreeDeliveryInstalled) return;
  window.__cfFreeDeliveryInstalled = true;

  var THRESHOLD = 3000; // dollars, ex the delivery line itself
  var DELIVERY_RE = /perth\s*metro\s*delivery/i;
  var PICKUP_RE = /pick\s*-?\s*up/i;
  var LABEL_OLD_RE = /Delivery\s*\(\+\$\d+\)/;
  var LABEL_NEW = 'Delivery (FREE over $3,000)';
  // 2026-09-28 Pete approved: the calculators' delivery note gains the free-over-$3,000 line (approved-wording.md).
  var NOTE_OLD_RE = /\$99 flat rate Perth metro, GST included\./;
  var NOTE_NEW = '$99 Perth metro, GST included. Free Perth metro delivery on orders over $3,000.';

  function log() { try { console.log.apply(console, ['[cf-free-delivery]'].concat([].slice.call(arguments))); } catch (e) {} }
  function fmt(n) {
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 2 }).format(n); }
    catch (e) { return '$' + Number(n || 0).toFixed(2); }
  }

  function calc() {
    var c = window.glassCalculator;
    return (c && c.state && Array.isArray(c.state.quoteBreakdown)) ? c : null;
  }

  // ---- 1) relabel the static radio text, once, wherever it appears --------
  function fixLabels() {
    // Simple text-node walk - the label is a handful of DOM nodes, not thousands.
    var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = tw.nextNode())) {
      if (LABEL_OLD_RE.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue.replace(LABEL_OLD_RE, LABEL_NEW);
      }
      if (NOTE_OLD_RE.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue.replace(NOTE_OLD_RE, function () { return NOTE_NEW; });
      }
    }
  }

  // ---- 2) find the delivery-note element for the nudge line ---------------
  function deliveryNoteEl() {
    return document.getElementById('delivery-note');
  }

  function upsertNudge(text) {
    var note = deliveryNoteEl();
    if (!note || !note.parentNode) return;
    var el = document.getElementById('cf-free-delivery-nudge');
    if (!text) { if (el) el.style.display = 'none'; return; }
    if (!el) {
      el = document.createElement('p');
      el.id = 'cf-free-delivery-nudge';
      el.style.cssText = 'font-size:12px;color:#0e9ed5;margin:4px 0 0;font-weight:600;';
      note.parentNode.insertBefore(el, note.nextSibling);
    }
    el.style.display = '';
    el.textContent = text;
  }

  // ---- 3) correct the breakdown + the on-screen totals ---------------------
  function correctTotal(delta) {
    if (!delta) return;
    ['final-quote', 'components-quote', 'instant-quote'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var m = /\$([\d,]+\.\d{2})/.exec(el.textContent || '');
      if (!m) return;
      var current = parseFloat(m[1].replace(/,/g, ''));
      var next = Math.max(0, current + delta);
      el.textContent = el.textContent.replace(m[0], fmt(next));
    });
  }

  // Pure function: find + correct the delivery line in a breakdown array in
  // place. Shared by (a) the live poll against the calculator's own state and
  // (b) the localStorage guard below that catches the value at the actual
  // moment it is persisted - see the note above that guard for why (b) turned
  // out to be necessary, not just (a).
  function correctBreakdownArray(bd) {
    if (!Array.isArray(bd)) return 0; // returns the cents delta applied (+/-), *100 to stay integer-safe... actually dollars delta
    var line = null;
    for (var i = 0; i < bd.length; i++) {
      var it = bd[i];
      if (it && it.category === 'Delivery' && DELIVERY_RE.test(it.item || '') && !PICKUP_RE.test(it.item || '')) { line = it; break; }
    }
    if (!line) return 0;

    if (line.__cfOrigTotal === undefined) {
      line.__cfOrigTotal = line.totalPrice;
      line.__cfOrigUnit  = line.unitPrice;
      line.__cfOrigItem  = line.item;
    }

    var kitSubtotal = 0;
    for (var j = 0; j < bd.length; j++) { if (bd[j] !== line) kitSubtotal += (bd[j].totalPrice || 0); }

    var shouldBeFree = kitSubtotal >= THRESHOLD;
    var isFree = line.totalPrice === 0 && line.__cfFreeApplied === true;
    var delta = 0;

    if (shouldBeFree && !isFree) {
      delta = -(line.__cfOrigTotal - 0);
      line.unitPrice = 0;
      line.totalPrice = 0;
      line.item = 'Perth Metro Delivery — FREE (order over $3,000)';
      line.__cfFreeApplied = true;
    } else if (!shouldBeFree && isFree) {
      delta = line.__cfOrigTotal;
      line.unitPrice = line.__cfOrigUnit;
      line.totalPrice = line.__cfOrigTotal;
      line.item = line.__cfOrigItem;
      line.__cfFreeApplied = false;
    }
    return delta;
  }

  // ---- 3b) THE LAST-MILE GUARD — correct at the moment the quote is SAVED --
  // Found in testing 2026-09-22: apply() runs on a 350ms poll, and even
  // wrapping proceedToQuotePage() for a synchronous pre-save pass was not
  // enough — some recalculation between the wrap firing and the actual
  // localStorage write could still put the raw $90/$99 charge back, and that
  // stale value is what quote-review, the CRM enquiry and the branded PDF all
  // read. The one place that CANNOT be outrun is the write itself: every save
  // path (proceedToQuotePage, "Email me this quote", any future one) ends in
  // localStorage.setItem('<calc>_active_quote'|'<calc>_quotes', json). Correct
  // the object right there, same pattern as cf-cart-spigot-guard.js correcting
  // the outbound /cart/add payload — the last point before the money, not the
  // display layer above it.
  var QUOTE_KEY_RE = /_(active_quote|quotes)$/;
  var origSetItem = Storage.prototype.setItem;
  Storage.prototype.setItem = function (key, value) {
    try {
      if (typeof key === 'string' && QUOTE_KEY_RE.test(key) && typeof value === 'string') {
        var parsed = JSON.parse(value);
        var touched = false;
        var fixOne = function (q) {
          if (!q || !Array.isArray(q.breakdown)) return;
          var delta = correctBreakdownArray(q.breakdown);
          if (delta && typeof q.grandTotal === 'number') { q.grandTotal = Math.max(0, q.grandTotal + delta); touched = true; }
          else if (delta) { touched = true; }
        };
        if (Array.isArray(parsed)) parsed.forEach(fixOne);
        else fixOne(parsed);
        if (touched) {
          value = JSON.stringify(parsed);
          log('corrected delivery on save ->', key);
        }
      }
    } catch (e) { /* not JSON, or not ours — pass through untouched */ }
    return origSetItem.call(this, key, value);
  };

  function apply() {
    fixLabels();

    var c = calc();
    if (!c) { upsertNudge(null); return; }
    var bd = c.state.quoteBreakdown;

    var line = null;
    for (var i = 0; i < bd.length; i++) {
      var it = bd[i];
      if (it && it.category === 'Delivery' && DELIVERY_RE.test(it.item || '') && !PICKUP_RE.test(it.item || '')) { line = it; break; }
    }
    if (!line) { upsertNudge(null); return; }

    // Remember the calculator's OWN charge exactly once, so a later edit
    // that drops the subtotal back under $3,000 restores the real number
    // instead of a guessed one.
    if (line.__cfOrigTotal === undefined) {
      line.__cfOrigTotal = line.totalPrice;
      line.__cfOrigUnit  = line.unitPrice;
      line.__cfOrigItem  = line.item;
    }

    var kitSubtotal = 0;
    for (var j = 0; j < bd.length; j++) { if (bd[j] !== line) kitSubtotal += (bd[j].totalPrice || 0); }

    var shouldBeFree = kitSubtotal >= THRESHOLD;
    var isFree = line.totalPrice === 0 && line.__cfFreeApplied === true;

    if (shouldBeFree && !isFree) {
      var removed = line.__cfOrigTotal - 0;
      line.unitPrice = 0;
      line.totalPrice = 0;
      line.item = 'Perth Metro Delivery — FREE (order over $3,000)';
      line.__cfFreeApplied = true;
      if (typeof c.state.grandTotal === 'number') c.state.grandTotal = Math.max(0, c.state.grandTotal - removed);
      correctTotal(-removed);
      upsertNudge(null);
      log('delivery FREE — kit subtotal', fmt(kitSubtotal));
    } else if (!shouldBeFree && isFree) {
      var restored = line.__cfOrigTotal;
      line.unitPrice = line.__cfOrigUnit;
      line.totalPrice = line.__cfOrigTotal;
      line.item = line.__cfOrigItem;
      line.__cfFreeApplied = false;
      if (typeof c.state.grandTotal === 'number') c.state.grandTotal = c.state.grandTotal + restored;
      correctTotal(restored);
      log('delivery restored — kit subtotal dropped to', fmt(kitSubtotal));
    }

    // 2026-09-28 Pete: "hide the add wording" — the "Add $X more for FREE Perth metro delivery." nudge is off.
    upsertNudge(null);
    if (line.__cfFreeApplied === true) fixScreen(c, kitSubtotal, line.__cfOrigTotal);
  }

  // ---- 3c) the SCREEN still showing the delivery charge after the data is free ----
  // Found 24 Oct 2026 (Pete, Leanne's PerfMesh quote: "fix the perfmesh calculator $99"): on the Configure
  // step the calculator draws the price panel BEFORE apply() zeroes the delivery line, and the panel shows
  // only the section on screen (cf-current-section-parts.js). So a 2-section job of $5,667.37 with a small
  // section 2 showed "Perth Metro Delivery $99.00" and Total $5,766.37, and "Email me this quote" sent that
  // $99 to the CRM. state.quoteBreakdown itself was right (whole job, delivery FREE). correctTotal() only
  // moves the three total boxes on a change of state, so a redraw after it leaves the stale $99 standing.
  // Here, every pass: any figure on screen that is EXACTLY the kit subtotal + the delivery charge is put
  // back to the kit subtotal, and any delivery row still charging is shown FREE. A figure that is not off by
  // exactly the delivery charge is never touched.
  function near(a, b) { return Math.abs(a - b) < 0.011; }
  function moneyIn(text) {
    var m = /\$\s*([\d,]+(?:\.\d{1,2})?)/.exec(text || '');
    return m ? parseFloat(m[1].replace(/,/g, '')) : null;
  }
  function fixScreen(c, kitSubtotal, charge) {
    try {
      charge = Number(charge) || 0;
      if (!(charge > 0)) return;
      var stale = kitSubtotal + charge;
      // the calculator's own figure (PerfMesh keeps the job total in state.quote, the others in grandTotal)
      if (typeof c.state.quote === 'number' && near(c.state.quote, stale)) c.state.quote = Math.round(kitSubtotal * 100) / 100;
      // the three total boxes
      ['final-quote', 'components-quote', 'instant-quote'].forEach(function (id) {
        var el = document.getElementById(id);
        var v = el && moneyIn(el.textContent);
        if (v != null && near(v, stale)) el.textContent = el.textContent.replace(/\$\s*[\d,]+(?:\.\d{1,2})?/, fmt(kitSubtotal));
      });
      var hosts = document.querySelectorAll('#quote-breakdown, #breakdown-content-configure, #breakdown-content, #breakdown-content-final');
      for (var h = 0; h < hosts.length; h++) {
        var host = hosts[h];
        // a delivery row still charging
        var items = host.querySelectorAll('.breakdown-item');
        for (var i = 0; i < items.length; i++) {
          var nameEl = items[i].querySelector('.item-name');
          var name = nameEl ? nameEl.textContent : '';
          if (!DELIVERY_RE.test(name) || PICKUP_RE.test(name) || /free/i.test(name)) continue;
          var prices = items[i].querySelectorAll('.item-pricing > div');
          var shown = prices.length ? moneyIn(prices[prices.length - 1].textContent) : null;
          if (shown == null || !near(shown, charge)) continue;
          nameEl.textContent = 'Perth Metro Delivery — FREE (order over $3,000)';
          for (var p = 0; p < prices.length; p++) prices[p].textContent = prices[p].textContent.replace(/\$\s*[\d,]+(?:\.\d{1,2})?/, '$0.00');
          // its group heading ("Delivery  $99.00")
          var grp = items[i].parentNode, head = grp && grp.firstElementChild;
          if (head && head !== items[i]) {
            var hs = head.querySelectorAll('span');
            var amt = hs.length ? hs[hs.length - 1] : null;
            if (amt && near(moneyIn(amt.textContent) || -1, charge)) amt.textContent = amt.textContent.replace(/\$\s*[\d,]+(?:\.\d{1,2})?/, '$0.00');
          }
        }
        // the panel's own Total line
        var spans = host.querySelectorAll('span');
        for (var s = 0; s < spans.length; s++) {
          if (!/^\s*total\s*$/i.test(spans[s].textContent)) continue;
          var val = spans[s].nextElementSibling;
          var v2 = val && moneyIn(val.textContent);
          if (v2 != null && near(v2, stale)) val.textContent = val.textContent.replace(/\$\s*[\d,]+(?:\.\d{1,2})?/, '$' + (Math.round(kitSubtotal * 100) / 100).toFixed(2));
        }
      }
    } catch (e) { log('screen correction error', e); }
  }

  function schedule() {
    if (schedule._t) return;
    schedule._t = setTimeout(function () { schedule._t = null; try { apply(); } catch (e) { log('error', e); } }, 350);
  }

  // ---- close the race: correct SYNCHRONOUSLY at the exact rebuild point ----
  // Found in testing 2026-09-22, in three stages:
  //   1. apply() runs on a 350ms poll — a section edit that recomputes the
  //      breakdown (putting the $90/$99 charge back) followed almost
  //      immediately by "Continue to Checkout" can win that race and save the
  //      stale total.
  //   2. Wrapping proceedToQuotePage() to run apply() BEFORE calling the
  //      original was not enough either: proceedToQuotePage()'s own first
  //      line is `this.updateQuoteDisplay()`, which REBUILDS
  //      state.quoteBreakdown from scratch — silently undoing the
  //      just-applied correction a moment later, before grandTotal/payload
  //      are computed from it.
  //   3. A Storage.prototype.setItem guard (belt-and-braces, left in place
  //      below) turned out not to be reachable either: some other script on
  //      this page has already given `localStorage` an own `setItem`
  //      property that shadows the prototype method for lookups, so
  //      `localStorage.setItem(...)` never dispatches through
  //      Storage.prototype at all in this environment.
  // The fix that actually holds: wrap updateQuoteDisplay() ITSELF and run
  // apply() synchronously immediately AFTER the original returns, every
  // single time it runs — not just before a save. Since proceedToQuotePage()
  // reads state.quoteBreakdown right after calling updateQuoteDisplay(), the
  // correction is already in place by the time anything downstream (grand
  // total math, the saved payload, the CRM enquiry, the PDF) reads it.
  var wrappedUpdate = false, wrappedProceed = false;
  function wrapCalculatorMethods() {
    var c = window.glassCalculator;
    if (!c) return;
    var proto = Object.getPrototypeOf(c);
    if (!proto || proto.__cfFreeDeliveryWrapped) { wrappedUpdate = wrappedProceed = true; return; }

    if (typeof proto.updateQuoteDisplay === 'function') {
      var origUpdate = proto.updateQuoteDisplay;
      proto.updateQuoteDisplay = function () {
        var r = origUpdate.apply(this, arguments);
        try { apply(); } catch (e) { log('post-rebuild correction error', e); }
        return r;
      };
      wrappedUpdate = true;
    }
    if (typeof proto.proceedToQuotePage === 'function') {
      var origProceed = proto.proceedToQuotePage;
      proto.proceedToQuotePage = function () {
        try { apply(); } catch (e) { log('pre-save correction error', e); }
        return origProceed.apply(this, arguments);
      };
      wrappedProceed = true;
    }
    if (wrappedUpdate || wrappedProceed) {
      proto.__cfFreeDeliveryWrapped = true;
      log('updateQuoteDisplay/proceedToQuotePage wrapped for a synchronous correction (update=' + wrappedUpdate + ', proceed=' + wrappedProceed + ')');
    }
  }

  function start() {
    schedule();
    setInterval(schedule, 350);
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('click', schedule, true);
    document.addEventListener('input', schedule, true);
    document.addEventListener('change', schedule, true);

    var tryWrap = setInterval(function () {
      wrapCalculatorMethods();
      if (wrappedUpdate && wrappedProceed) clearInterval(tryWrap);
    }, 300);
    setTimeout(function () { clearInterval(tryWrap); }, 20000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
